import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import "./linkfield.scss";

const LinkField = ({ link, name, airalabel, rel, title, handleSubMenuOpen, submenu }) => {
    return (
        <>

            <Link to={`${process.env.REACT_APP_STATIC_UI_URL}${link}`} aira-label={airalabel} rel={rel} title={title} onClick={handleSubMenuOpen}>
                {!!submenu &&
                    <svg className="arrow-right-cs" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                        <path d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z" />
                    </svg>}
                {name}
                {!link && <svg className="arrow-down-cs" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                </svg>}
            </Link>
        </>
    )
}

export default memo(LinkField)